const appLabOrg = {
  'EMS': '68fdee6f-05bc-49d9-92c8-42cdd28304ae',
  'NURSING': '6446dade83fc7c00146b775b'
};

const appLabOrgName = {
  '68fdee6f-05bc-49d9-92c8-42cdd28304ae': 'VRpatients Public',
  '6446dade83fc7c00146b775b': 'VRpatients Public Nursing'
};

function getAppLabOrg(productType) {
  return appLabOrg[productType] || appLabOrg['EMS'];
}

function getAppLabOrgName(id) {
  return appLabOrgName[id];
}

function isAppLabOrg(id) {
  return !!Object.values(appLabOrg).includes(id);
}

function hasAppLab(productType) {
  return !!Object.keys(appLabOrg).includes(productType);
}

exports.getAppLabOrg = getAppLabOrg;
exports.getAppLabOrgName = getAppLabOrgName;
exports.isAppLabOrg = isAppLabOrg;
exports.hasAppLab = hasAppLab;

